const API_BASE_URL = process.env.API_BASE_URL;

const CALCULATE_PERCENT = 1;
const CALCULATE_UNIT = 2;
const CALCULATE_BRAND = 3;
const CALCULATE_BASE_COST = 4;
const CALCULATE_DEPARTURE = 5;
const CALCULATE_UP_FROM = 6;
const CALCULATE_UNIT_PERCENT = 7;

const lang = $('html').attr('lang');

Vue.use(window.vuelidate.default);

const { required, email } = window.validators;

const customPhone = (value) => !!value && /\+[0-9]{10,12}/.test(value.replace(/[\s\-\(\)]/g, ''));

Vue.filter('splitNumber', function (value) {
   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
});

var app = new Vue({
    el: '#calculator',
    delimiters: ['<%','%>'],
    data: {
        step: 1,
        errors: {
            step1: false,
            step2: false,
            step3: false,
        },
        addresses: [],
        brands: [],
        selectedBrand: null,
        brandChanged: false,
        categories: [],
        selectedCategories: [],
        orderedCategories: [],
        formAdditionalFieldsShowed: false,
        form: {
            name: null,
            phone: '+7',
            email: null,
            order_date: null,
            order_time: null,
            street: null,
            house: null,
            flat: null,
            payment_type: 1,
            agreement: false,
        }
    },
    validations: {
        form: {
            phone: {
                required,
                customPhone
            },
            email: {
                email
            },
            agreement: {
                checked: value => value === true
            }
        }
    },
    mounted() {
        axios
            .get(API_BASE_URL + 'furniture-brands/?format=json&lang=' + lang)
            .then(
                response => {
                    this.brands = response.data
                    history.pushState({step: 1}, null, null);
                }
            );
        if(window.user) {
            let user = window.user;
            this.form.name = user.full_name;
            this.form.phone = user.phone;
            this.form.email = user.email;
            this.form.street = user.street ? user.street : null;
            this.form.house = user.house ? user.house : null;
            this.form.flat = user.flat ? user.flat : null;
        }
        // axios
        //     .get(BASE_API_URL + 'vehicles/?format=json&lang=' + lang)
        //     .then(
        //         response => {
        //             this.vehicles = response.data
        //         }
        //     );
    },
    methods: {
        changeStep: function(step) {
            if(step > this.step) {
                history.pushState({step: step}, null, null);
            }
            this.step = step;
        },
        backToStep: function(step) {
            if(this.step > step) {
                this.step = step;
            }
        },
        goToStep1: function() {
            this.selectedBrand = null;
            this.changeStep(1);
        },
        goToStep2: function() {
            // this.selectedCategories = [];
            if(!this.selectedBrand || this.selectedBrand.is_hidden) {
                this.errors.step1 = true;
            } else {
                if(this.brandChanged) {
                    let url = (
                        API_BASE_URL + 'furniture-categories/?format=json&lang='
                        + lang + '&brand=' + this.selectedBrand.id
                    );
                    axios
                        .get(url)
                        .then(
                            response => {
                                this.categories = response.data;
                                this.brandChanged = false;
                                this.changeStep(2);
                            }
                        );
                } else {
                    this.changeStep(2);
                }
            }
        },
        goToStep3: function() {
            let selectedCategoriesIds = this.selectedCategories.map(category => category.id);
            // remove non selected categories that existed in ordered categories
            if(selectedCategoriesIds.length === 0) {
                this.errors.step2 = true;
            } else {
                for (let i = this.orderedCategories.length - 1; i >= 0; i--) {
                    let category = this.orderedCategories[i];
                    if(!selectedCategoriesIds.includes(category.id)) {
                        this.orderedCategories.splice(i, 1);
                    }
                }
                // add only new categories
                for(let category of this.selectedCategories) {
                    if(!this.orderedCategoriesIds.includes(category.id)) {
                        this.orderedCategories.push(copyCategory(category));
                    }
                }

                this.changeStep(3);
            }
                
        },
        goToStep4: function () {
            if(this.orderedCategories.length === 0) {
                this.errors.step3 = true;
            } else {
                this.changeStep(4);
            }
        },
        goToStep5: function() {
            this.changeStep(5);
        },
        selectBrand: function(brand) {
            this.brandChanged = true;
            this.selectedBrand = brand;
        },
        selectSeries: function (category, series) {
            category.selectedSeries = series;
        },
        selectType: function (category, type) {
            category.selectedType = type;
        },
        addCategory: function(category, index) {
            category.isLastOfCategory = false;
            this.orderedCategories.splice(index + 1, 0, copyCategory(category));
        },
        removeCategory: function(index) {
            let previousElement = this.orderedCategories[index - 1];
            if(previousElement && previousElement.id == this.orderedCategories[index].id) {
                this.orderedCategories[index - 1].isLastOfCategory = true
            }
            Vue.delete(this.orderedCategories, index);
        },
        addService: function(index, service, category) {
            category.selectedServices.push(category.orderServices[index]);
            Vue.delete(category.orderServices, index);
            category.servicesShowed = false;
        },
        removeService: function(index, service, category) {
            category.orderServices.push(category.selectedServices[index]);
            Vue.delete(category.selectedServices, index);
        },
        changeCategoryQuantity: function(category, value) {
            if(category.quantity + value > 0) {
                category.quantity += value;
            }
        },
        changeServiceQuantity: function(service, value) {
            if(service.quantity + value > 0) {
                service.quantity += value;
            }
        },
        getTotalCost: function() {
            let totalCost = 0;
            return totalCost;
        },
        showServices: function(category) {
            category.servicesShowed = true;
        },
        showFormAdditionalFields: function() {
            this.formAdditionalFieldsShowed = true;
        },
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        },
        brandOrder: function(brandId) {
            this.step = 1;
            this.brandChanged = true;
            for(let brand of this.brands) {
                if(brand.id == brandId) {
                    this.selectedBrand = brand;
                    break;
                }
            }
            if(this.selectedBrand) {
                this.goToStep2();
            }
        },
        serviceOrder: function(brandId, categoryId) {
            this.selectedCategories = [];
            for(let brand of this.brands) {
                if(brand.id == brandId) {
                    this.selectedBrand = brand;
                }
            }
            let url = (
                API_BASE_URL + 'furniture-categories/?format=json&lang='
                + lang + '&brand=' + this.selectedBrand.id
            );
            axios
                .get(url)
                .then(
                    response => {
                        this.categories = response.data;
                        this.selectedCategories = this.categories.filter(
                            category => category.id == categoryId
                        );
                        this.goToStep3();
                    }
                );
        },
        updateAddresses: function (event){
            if(event.target.value) {
                ymaps.suggest(event.target.value)
                .then(items => {
                    this.addresses = items.slice(0, 5).map(item => item.displayName);
                });
            }
         },
        selectAddress: function(address) {
            this.form.street = address;
            this.addresses = [];
        },
        submit: function() {
            let that = this;
            this.$v.$touch();
            if(!this.$v.$invalid) {
                let data = this.form;
                let config = {
                    headers: {
                        'X-CSRFToken': this.$cookies.get('csrftoken')
                    }
                };
                let orderItems = this.orderedCategories.map(
                    category => {
                        let orderItem = {
                            category_id: category.id,
                            price: category.price ? category.price : null,
                            quantity: category.quantity ? category.quantity : null,
                            is_brand: category.is_brand,
                        }
                        if(category.selectedSeries) {
                            orderItem.furniture_series = category.selectedSeries.id;
                        }
                        if(category.selectedType) {
                            orderItem.furniture_type = category.selectedType.id;
                        }
                        if(category.selectedServices.length) {
                            orderItem.order_services = category.selectedServices.map(
                                service => {
                                    return {
                                        service_id: service.id,
                                        price: service.price ? service.price : null,
                                        quantity: service.quantity ? service.quantity : null,
                                    }
                                })
                        }
                        return orderItem;
                    }
                )
                data.order_items = orderItems;
                axios
                    .post('/create-order/', data, config)
                    .then( (response) => {
                        if (response.status == 200 && response.data.error == false) {
                            this.changeStep(6);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                let form = this.$v.form;
                if(form.phone.$error) {
                    $('html, body').animate(
                        {
                            scrollTop: $('#phone-field').offset().top - 100
                        }, 300
                    );
                } else if(form.email.$error) {
                    $('html, body').animate(
                        {
                            scrollTop: $('#email-field').offset().top - 100
                        }, 300
                    );
                } else if(form.agreement.$error) {
                    $('html, body').animate(
                        {
                            scrollTop: $('#agreement-field').offset().top - 100
                        }, 300
                    );
                }
            }
        },
        resetCalculator: function() {
            this.selectedBrand = null;
            this.changeStep(1);
        },
    },
    computed: {
        totalCost: function() {
            let totalCost = 0;
            for(let category of this.orderedCategories) {
                totalCost += category.getCost();
                if (category.selectedServices.length) {
                    totalCost += category.selectedServices.reduce(
                        (a, b) => +a + +b.getCost(), 0
                    );
                }
            }
            return totalCost;
        },
        orderedCategoriesIds: function() {
            return this.orderedCategories.map(category => category.id);
        }
    },
    watch: {
        step: function(){
            window.scrollTo(0, this.$el.offsetTop);
            let scrollTo;
            if(this.step === 1) {
                scrollTo = 0;
            } else if(this.step > 1 && this.step < 4) {
                scrollTo = $('.stepper__step_active').offset().left + $('.stepper__step_active').width() - 10;
            } else if(this.step === 4) {
                scrollTo = $('.stepper__steps').width();
            }
            if(scrollTo !== undefined) {
                $('.stepper__steps').scrollLeft(scrollTo);
            }
        },
        selectedBrand: function(val) {
            this.selectedCategories = [];
            this.brandChanged = true;
            if(val) {
                this.errors.step1 = false;
            }
        },
        selectedCategories: function(val) {
            if(val.length > 0) {
                this.errors.step2 = false;
            }
        },
        orderedCategories: function(val) {
            if(val.length > 0) {
                this.errors.step3 = false;
            }
        }
    }
});


window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state !== null && state.step) {
        if(state.step < app.step){
            app.backToStep(state.step);
        }
        if(state.step == 1) {
            window.history.replaceState({}, null, null);
        }
    }
    // history.back();
});

$('.js-furniture-brand').click(function(){
    $('.furniture__brend').removeClass('furniture__brend_active');
    $(this).addClass('furniture__brend_active');
    app.brandOrder($(this).data('brand'));
    // $([document.documentElement, document.body]).animate({
    //     scrollTop: $('#calculator').offset().top
    // }, 500);
});

$('.js-service-order').click(function(){
    // app.serviceOrder($(this).data('brand'), $(this).data('category'));
    $([document.documentElement, document.body]).animate({
        scrollTop: $('#calculator').offset().top
    }, 500);
    // $('.service-popup').fadeOut(500);
    // $('.popup-wrapper').fadeOut(300);
});

$('body').on('click', '.js-show-services', function(e){
    $(this).parent().find('._form-dropdown').show();
    e.stopPropagation();
});

$(document).click(function(){
  $('._form-dropdown:visible').hide();
});

function copyService(service) {
    const orderedService = {
        quantity: 0,
        price: 0,
        showPrice: function() {
            if(
                this.calculation_type == CALCULATE_UNIT_PERCENT ||
                this.calculation_type == CALCULATE_PERCENT ||
                this.calculation_type == CALCULATE_UP_FROM
            ) {
                return true;
            }
            return false;
        },
        showQuantity: function() {
            if(
                this.calculation_type == CALCULATE_UNIT ||
                this.calculation_type == CALCULATE_UNIT_PERCENT ||
                this.calculation_type == CALCULATE_DEPARTURE ||
                this.calculation_type == CALCULATE_BRAND
            ) {
                return true;
            }
            return false;
        },
        getUnitName: function() {
            return this.unit_name;
        },
        getUnitNamePlural: function() {
            return this.unit_name_plural;
        },
        getCost: function() {
            let cost = 0;
            switch(this.calculation_type) {
                case CALCULATE_PERCENT:
                    cost = Math.max(this.price * this.percent / 100, this.min_cost);
                    break;
                case CALCULATE_UNIT:
                    cost = this.quantity * this.cost_per_unit;
                    break;
                case CALCULATE_BRAND:
                    cost = (this.is_brand ? this.min_cost : this.non_brand_min_cost) * this.quantity;
                    break;
                case CALCULATE_BASE_COST:
                    cost = this.min_cost;
                    break;
                case CALCULATE_DEPARTURE:
                    cost = this.min_cost + this.quantity * this.cost_per_unit;
                    break;
                case CALCULATE_UP_FROM:
                    if(this.price <= this.up_price) {
                        cost = Math.max(this.price * this.up_percent / 100, this.up_min_cost);
                    } else {
                        cost = Math.max(this.price * this.from_percent / 100, this.from_min_cost);
                    }
                    break;
                case CALCULATE_UNIT_PERCENT:
                    cost = source.min_cost + (
                        this.price * source.percent / 100
                    ) * this.quantity;
                    break;
            }
            return Math.round(cost);
        },
    }
    return Object.assign({}, service, orderedService);
}

function copyCategory(category) {
    const orderedCategory = {
        selectedSeries: null,
        selectedType: null,
        selectedServices: [],
        orderServices: category.additional_services.map(
            service => {
                return copyService(service);
            }
        ),
        quantity: 0,
        price: 0,
        isLastOfCategory: true,
        is_brand: null,
        servicesShowed: false,
        getSource: function() {
            if(this.selectedSeries && this.selectedSeries.hasOwnProperty('calculation_type')) {
                return this.selectedSeries;
            } else if(this.selectedType && this.selectedType.hasOwnProperty('calculation_type')) {
                return this.selectedType;
            }
            return this;
        },
        getUnitName: function() {
            const source = this.getSource();
            return source.unit_name;
        },
        getUnitNamePlural: function() {
            const source = this.getSource();
            return source.unit_name_plural;
        },
        getCost: function() {
            const source = this.getSource();
            let cost = 0;
            switch(source.calculation_type) {
                case CALCULATE_PERCENT:
                    cost = Math.max(this.price * source.percent / 100, source.min_cost);
                    break;
                case CALCULATE_UNIT:
                    cost = this.quantity * source.cost_per_unit;
                    break;
                case CALCULATE_BRAND:
                    cost = (this.is_brand ? source.min_cost : source.non_brand_min_cost) * this.quantity;
                    break;
                case CALCULATE_BASE_COST:
                    cost = source.min_cost;
                    break;
                case CALCULATE_DEPARTURE:
                    cost = source.min_cost + this.quantity * source.cost_per_unit;
                    break;
                case CALCULATE_UP_FROM:
                    if(this.price <= source.up_price) {
                        cost = Math.max(this.price * source.up_percent / 100, source.up_min_cost);
                    } else {
                        cost = Math.max(this.price * source.from_percent / 100, source.from_min_cost);
                    }
                    break;
                case CALCULATE_UNIT_PERCENT:
                    cost = source.min_cost + (
                        this.price * source.percent / 100
                    ) * this.quantity;
                    break;
            }
            return Math.round(cost);
        },
        showPrice: function() {
            const source = this.getSource();
            if(
                source.calculation_type == CALCULATE_UNIT_PERCENT ||
                source.calculation_type == CALCULATE_PERCENT ||
                source.calculation_type == CALCULATE_UP_FROM
            ) {
                return true;
            }
            return false;
        },
        showQuantity: function() {
            const source = this.getSource();
            if(
                source.calculation_type == CALCULATE_UNIT ||
                source.calculation_type == CALCULATE_UNIT_PERCENT ||
                source.calculation_type == CALCULATE_DEPARTURE ||
                source.calculation_type == CALCULATE_BRAND
            ) {
                return true;
            }
            return false;
        },
        showBrand: function() {
            const source = this.getSource();
            if(source.calculation_type == CALCULATE_BRAND) {
                return true;
            }
            return false;
        }
    };
    return Object.assign({}, category, orderedCategory);
}


// WEBPACK FOOTER //
// ./js/pages/calculator.js